<template>
  <div class="container1">
    <!-- {{ $i18n.locale }} -->
    <!-- <div @click="testFn">testFn</div> -->
    <div :class="['box']">
      <div class="icon-box">
        <i class="el-icon-success icon-check"></i>
        <!-- <i class="el-icon-check icon-check"></i> -->
      </div>
      <div :class="[isMobile ? 'success-mobile' : 'success']">
        {{ $t("home.submitted_") }}
      </div>

      <div class="mt-5 underline"><router-link to="/">返回</router-link></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubmittedSuccess",
  data() {
    return {
      isMobile: false,
      screenWidth: window.innerWidth,
    };
  },
  mounted() {
    // let lang = window.sessionStorage.getItem("sessionLang") || "zh";
    // console.log("不存在 :>> sessionStorage", lang);
    // this.$i18n.locale = lang;
    window.addEventListener("resize", this.handleResize);
  },
  //   onUnmounted(() => {
  //   window.removeEventListener('resize', handleResize);
  // })
  methods: {
    handleResize() {
      console.log("handleResize :>> ");
      this.screenWidth = window.innerWidth;
      if (this.screenWidth < 750) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    // testFn() {
    //   this.$i18n.locale = "en";
    // },
  },
};
</script>

<style lang="scss" scoped>
.container1 {
  height: 100vh;
  text-align: center;
  position: relative;

  // background-color: #f5f5f5;
  .box {
    // width: 210px;
    width: 260px;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 510px;
    padding: 45px 0 65px;
    border-radius: 8px;
    // box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    background-color: #fff;
  }

  .icon-check {
    font-size: 100px;
    // font-size: 60px;
    font-weight: 600;
    color: #85ce61;
  }

  // ------------------------ 手机，小屏**start ------------------------
  .success-mobile {
    padding-top: 15px;
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }

  // ------------------------ 手机，小屏**end ------------------------
  .success {
    padding-top: 16px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    color: #333;
  }

  .icon-box {
    // max-width: 90px;
    margin: 0px auto 10px;
    color: #78c440;
  }
}
</style>
